import React from "react";

interface DeleteIconProps {
  className?: string;
  onClick?: () => void;
}

const DeleteIcon: React.FC<DeleteIconProps> = ({ className, onClick }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <rect width="32" height="32" rx="6" fill="#EA4335" />
      <path
        d="M24.25 9.25H7.75"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.25 6.25H19.75"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.75 9.25V23.5C22.75 23.6989 22.671 23.8897 22.5303 24.0303C22.3897 24.171 22.1989 24.25 22 24.25H10C9.80109 24.25 9.61032 24.171 9.46967 24.0303C9.32902 23.8897 9.25 23.6989 9.25 23.5V9.25"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DeleteIcon;
